export const eu = {
  'ad.label': 'Iragarkia',
  'ad.sponsored_by': '{advertiser} babeslearekin',
  'ad.visit': 'Bisitatu',
  'cookies.preferences': 'Cookie hobespenak',
  'cookies.title': 'Zure pribatutasuna, zure kontrolpean',
  'cookies.description': 'Beharrezko biltegiratzea erabiltzen dugu Albambam funtziona dezan. Analitika edo marketina soilik zure baimenarekin aktibatuko dugu. Edozein unetan kendu dezakezu. Kontsultatu',
  'cookies.privacy_link': 'Pribatutasun Politika',
  'cookies.close': 'Itxi hobespenak',
  'cookies.necessary': 'Beharrezkoak',
  'cookies.necessary_desc': 'Saioa, segurtasuna, hizkuntza eta oinarrizko hobespenak.',
  'cookies.analytics': 'Analitika',
  'cookies.analytics_desc': 'Erabilera neurketa anonimoa zerbitzua hobetzeko.',
  'cookies.marketing': 'Marketina',
  'cookies.marketing_desc': 'Iragarkien pertsonalizazioa eta kanpainen neurketa.',
  'cookies.configure': 'Konfiguratu',
  'cookies.reject': 'Baztertu aukerakoak',
  'cookies.save': 'Gorde hautaketa',
  'cookies.accept': 'Onartu guztiak',
  'lang.selector_label': 'Hizkuntza',
  'lang.changed': 'Hizkuntza aldatuta',
  'nav.home': 'Hasiera',
  'nav.categories': 'Kategoriak',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Adiskidetasuna',
  'nav.upload': 'Igo',
  'nav.profile': 'Profila',
  'nav.login': 'Sartu',
  'common.signed_in': 'Saioa hasita',
  'common.error': 'Errorea',
  'topbar.search_placeholder': 'Bilatu bideoak, sortzaileak...',
  'legal.terms': 'Baldintzak',
  'legal.privacy': 'Pribatutasuna',
  'nav.admin': 'Administrazioa',
  'nav.logout': 'Itxi saioa',
  'admin.tab.payments': 'Ordainketak',
  'admin.payments.title': 'Ordainketak',
  'cats.title': 'Kategoriak',
  'cats.all': 'Denak',
  'cats.adult_title': '+18 kategoriak',
  'cats.empty': 'Ez dago bideorik kategoria honetan.',
  'friends.block_confirm': 'Lagun hau blokeatu? Ezingo duzue gehiago txateatu ezta lagun gisa ikusi.',
  'friends.accepted': 'Orain lagunak zarete!',
  'friends.title': 'Adiskidetasuna',
  'friends.subtitle': 'Elkarri jarraitzen diotenak bakarrik bihurtzen dira lagun eta pribatuki txateatu dezakete.',
  'friends.unread_count_label': '{n} mezu irakurtzeko',
  'friends.blocked_users_title': 'Blokeatutako erabiltzaileak',
  'friends.unblock_user': 'Desblokeatu',
  'friends.requests_title': 'Txat eskaerak',
  'friends.request_badge': 'Eskaera',
  'friends.request_accept': 'Onartu',
  'friends.request_ignore': 'Ez ikusi egin',
  'friends.empty_title': 'Oraindik ez duzu lagunik',
  'friends.empty_subtitle': 'Jarraitu norbaiti eta itzularazi jarraipena txat pribatua desblokeatzeko.',
  'friends.attach_image': 'Argazkia',
  'friends.shared_video_label': 'Bideo bat partekatu du',
  'friends.select_conversation': 'Hautatu lagun bat txateatzen hasteko',
  'friends.block_user': 'Blokeatu',
  'friends.no_messages_yet': 'Oraindik ez dago mezurik. Agurtu!',
  'friends.message_placeholder': 'Idatzi mezu bat...',
  'section.trending': 'Joerak',
  'section.shorts': 'Shorts',
  'section.for_you': 'Zuretzat',
  'home.hero.badge': 'Ongi etorri Albambam-era',
  'home.hero.title_1': 'Bideo laburrak.',
  'home.hero.title_2': 'Benetako sortzaileak.',
  'home.hero.subtitle': 'Ikusi, partekatu eta irabazi. Igo zure bideoak eta aurkitu talentu berriak kategoria bakoitzean.',
  'home.hero.cta_shorts': 'Ikusi Shorts',
  'home.hero.cta_trending': 'Joerak',
  'home.shorts.see_all': 'Ikusi denak',
  'home.empty.title': 'Oraindik ez dago bideorik',
  'home.empty.subtitle': 'Sortzaileek edukia igotzen dutenean, hemen agertuko da.',
  'live.send_diamonds': 'Bidali diamanteak',
  'live.buy': 'Erosi',
  'live.chat': 'Txata',
  'live.type_message': 'Idatzi mezu bat...',
  'live.send': 'Bidali',
  'auth.success_google': 'Google-rekin saioa hasita',
  'auth.fail_google': 'Google saio baliogabea',
  'auth.success_login': 'Saioa hasita',
  'auth.success_register': 'Kontua sortuta',
  'auth.login_tab': 'Sartu',
  'auth.register_tab': 'Sortu kontua',
  'auth.email': 'Helbide elektronikoa',
  'auth.password': 'Pasahitza',
  'auth.submit_login_loading': 'Sartzen...',
  'auth.submit_login': 'Sartu',
  'auth.name': 'Izena',
  'auth.submit_register_loading': 'Sortzen...',
  'auth.submit_register': 'Sortu kontua',
  'auth.or': 'edo',
  'legal.privacy_title': 'Pribatutasun Politika',
  'search.title': '“{q}” bilaketaren emaitzak',
  'search.count': '{n} bideo',
  'search.empty': 'Emaitzarik ez.',
  'series.load_error': 'Ezin izan da seriea kargatu',
  'series.unlocked': 'Seriea desblokeatuta',
  'series.purchase_error': 'Ezin izan da erosketa hasi',
  'series.restricted': 'Sarbide mugatua',
  'series.configure_access': 'Konfiguratu sarbidea',
  'series.language_all': 'Hizkuntza guztiak',
  'series.episode_count': '{n} atal',
  'series.buy': 'Erosi seriea',
  'series.filter_language': 'Iragazi hizkuntzaren arabera',
  'series.no_episodes': 'Oraindik ez dago atalik argitaratuta.',
  'series.episode_number': '{n}. atala',
  'legal.terms_title': 'Baldintzak eta Baldintzak',
  'lang.ca': 'Katalana',
  'lang.en': 'Ingelesa',
  'lang.es': 'Gaztelania',
  'lang.fr': 'Frantsesa',
  'lang.de': 'Alemana',
  'lang.it': 'Italiera',
  'lang.eu': 'Euskara',
  'lang.gl': 'Galiziera',
  'lang.zh': 'Txinera',
  'lang.other': 'Besteak',
  'lang.vi': 'Vietnamera',
  'lang.ja': 'Japoniera',
  'lang.ko': 'Koreera',
  'lang.ru': 'Errusiera',
  'lang.ro': 'Errumaniera',
  'lang.ar': 'Arabiera',
  'lang.tr': 'Turkiera',
  'lang.pl': 'Poloniera',
  'lang.ms': 'Malaysiera',
  'lang.ta': 'Tamilera',
  'upload.series_title_error': 'Idatzi seriearen izenburua',
  'upload.series_adult_category_error': 'Hautatu +18 kategoria bat serierako',
  'upload.series_created': 'Seriea sortuta',
  'upload.series_create_error': 'Ezin izan da seriea sortu',
  'upload.err_file': 'Hautatu baliozko bideo fitxategi bat',
  'upload.err_title': 'Jarri izenburu bat',
  'upload.series_select_error': 'Hautatu edo sortu serie bat',
  'upload.trailer_target_error': 'Hautatu trailerraren bideoa edo seriea',
  'upload.price_error': 'Sartu gutxienez 0,50 EUR-ko baliozko prezio bat.',
  'upload.adult_category_error': 'Hautatu kategoria heldu bat',
  'upload.success': 'Bideoa behar bezala igo da',
  'upload.title_h': 'Igo bideo bat',
  'upload.kind': 'Argitalpen mota',
  'upload.kind_video': 'Bideo independentea',
  'upload.kind_episode': 'Serie bateko atala',
  'upload.kind_trailer': 'Trailerra publikoa Shorts-en',
  'upload.series': 'Seriea',
  'upload.series_select': 'Hautatu serie bat',
  'upload.episode': 'Atala',
  'upload.series_new_title': 'Serie berri baten izenburua',
  'upload.series_create': 'Sortu seriea',
  'upload.series_adult': '+18 seriea',
  'upload.series_premium': 'Premium seriea',
  'upload.series_adult_category': 'Seriearen +18 kategoria',
  'upload.series_price': 'Ataleko eta paketeako prezioa (EUR)',
  'upload.trailer_for': 'Trailerrak aurkezten du',
  'upload.trailer_select': 'Hautatu bideoa edo seriea',
  'upload.video_prefix': 'Bideoa',
  'upload.file_label': 'Bideo fitxategia (MP4, gehienez 1GB)',
  'upload.file_pick': 'Egin klik bideo bat hautatzeko',
  'upload.thumb_label': 'Miniatura (aukerakoa)',
  'upload.video_title': 'Izenburua',
  'upload.description': 'Deskribapena',
  'upload.category': 'Kategoria',
  'upload.is_short': 'Short bat da (bertikala)',
  'upload.paid_video': 'Ordainpeko bideoa',
  'upload.adult_content': '+18 edukia',
  'upload.video_language': 'Bideoaren hizkuntza',
  'upload.individual_price': 'Bideo hau ikusteko prezioa (EUR)',
  'upload.paid_video_help': 'Ikusleak bideo honetarako sarbide iraunkorra erosiko du soilik. Gutxieneko prezioa 0,50 EUR da.',
  'upload.adult_category': 'Kategoria heldua',
  'upload.uploading': 'Igotzen {n}%',
  'upload.submit': 'Igo bideoa',
  'user.followers': 'jarraitzaile',
  'user.following': 'jarraituak',
  'user.follow': 'Jarraitu',
  'user.chat_open': 'Txateatu',
  'user.request_sent': 'Eskaera bidalita',
  'user.send_message': 'Bidali mezua',
  'user.followers_title': 'Jarraitzaileak',
  'user.following_title': 'Jarraituak',
  'user.unfollow': 'Utzi jarraitzeari',
  'user.request_title': 'Txat eskaera',
  'user.request_subtitle': 'Mezu bakarra bidali dezakezu. Eskaera onartzen badu, lagun bihurtuko zarete eta txateatu ahal izango duzue.',
  'user.request_placeholder': 'Idatzi zure mezua...',
  'user.request_send': 'Bidali eskaera',
  'shorts.login_for_like': 'Hasi saioa Atsegin dut emateko',
  'watch.share_copied': 'Esteka kopiatuta',
  'watch.delete_confirm': 'Iruzkin hau ezabatu?',
  'ad.skip_in': 'Saltatu {n}s barru',
  'ad.skip': 'Saltatu iragarkia',
  'watch.share': 'Partekatu',
  'friends.share_video': 'Partekatu bideo bat',
  'friends.send': 'Bidali',
  'watch.comments': 'Iruzkinak',
  'watch.write_comment': 'Idatzi iruzkin bat...',
  'watch.publish': 'Argitaratu',
  'watch.login_to_comment': 'Saioa hasi behar da iruzkinak egiteko.',
  'watch.login_btn': 'Sartu iruzkinak egiteko',
  'watch.no_comments': 'Oraindik ez dago iruzkinik.',
  'watch.related': 'Erlazionatuak',
  'nav.trending': 'Joerak',
  'friends.follow_option_only_follow': 'Jarraitu',
  'friends.follow_option_friends': 'Lagunak',
  'watch.like': 'Atsegin dut',
  'watch.views_short': '{n} ikustaldi',
  'shorts.empty.title': 'Oraindik ez dago Shorts-ik',
  'shorts.empty.subtitle': 'Igo bideo labur bat atala estreinatzeko.',
  'shorts.share': 'Partekatu',
  'auth.continue_google': 'Jarraitu Google-rekin',
  'upload.is_premium': 'Premium',
  'upload.price': 'Prezioa (€)',
  'upload.err_select': 'Hautatu bideo bat',
  'profile.upload_btn': 'Igo bideoa',
  'profile.tab_videos': 'Nire bideoak ({n})',
  'profile.tab_history': 'Historia',
  'profile.tab_recos': 'Gomendioak',
  'profile.no_videos': 'Oraindik ez duzu bideorik igo.',
  'profile.no_history': 'Oraindik ez duzu bideorik ikusi.',
  'profile.no_recos': 'Ikusi bideo batzuk gomendioak jasotzeko.',
  'profile.likes': 'atsegite',
  'profile.views': 'ikustaldi',
  'wallet.title': 'Diru-zorroa',
  'wallet.rate_label': 'Tasa',
  'wallet.min_label': 'Gutxieneko erretiratzea',
  'wallet.amount_label': 'Erretiratzeko kopurua',
  'wallet.withdraw_btn': 'Eskatu erretiratzea',
  'wallet.history_title': 'Eskaeren historia',
  'wallet.success': 'Eskaera sortuta',
  'wallet.bad_amount': 'Kopuru baliogabea',
  'wallet.per_view': '{rate} {cur}/ikustaldi',
  'admin.title': 'Administrazioa',
  'admin.stats.users': 'Erabiltzaileak',
  'admin.stats.videos': 'Bideoak',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Ikustaldiak',
  'admin.tab.videos': 'Bideoak',
  'admin.tab.ads': 'Iragarkiak',
  'admin.tab.users': 'Erabiltzaileak',
  'admin.tab.withdrawals': 'Erretiratzeak',
  'admin.tab.config': 'Ezarpenak',
  'admin.tab.translations': 'Hizkuntzak',
  'tbl.title': 'Izenburua',
  'tbl.creator': 'Sortzailea',
  'tbl.category': 'Kategoria',
  'tbl.type': 'Mota',
  'tbl.views': 'Ikustaldiak',
  'tbl.likes': 'Atsegiteak',
  'tbl.status': 'Egoera',
  'tbl.actions': 'Ekintzak',
  'tbl.placement': 'Kokapena',
  'tbl.advertiser': 'Iragarlea',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Klikak',
  'tbl.active': 'Aktibo',
  'tbl.name': 'Izena',
  'tbl.email': 'Posta',
  'tbl.role': 'Rola',
  'tbl.wallet': 'Diru-zorroa',
  'tbl.amount': 'Kopurua',
  'tbl.date': 'Data',
  'tbl.user': 'Erabiltzailea',
  'video.video': 'Bideoa',
  'video.short': 'Short',
  'action.show': 'Argitaratu',
  'action.hide': 'Ezkutatu',
  'action.delete_confirm_video': 'Bideoa ezabatu?',
  'ad.create_h': 'Sortu iragarkia',
  'ad.title_label': 'Izenburua',
  'ad.image_label': 'Irudiaren URLa',
  'ad.target_label': 'Helburuko URLa',
  'ad.advertiser_label': 'Iragarlea',
  'ad.placement_label': 'Kokapena',
  'ad.placement.banner': 'Banner (webgunea)',
  'ad.placement.preroll': 'Pre-roll (bideoaren aurretik)',
  'ad.placement.overlay': 'Overlay (bideoaren barruan)',
  'ad.active': 'Aktibo',
  'ad.create_btn': 'Sortu',
  'ad.success_create': 'Iragarkia sortuta',
  'ad.delete_confirm': 'Iragarkia ezabatu?',
  'users.make_admin': 'Egin admin',
  'users.remove_admin': 'Kendu admin',
  'wd.approve': 'Onartu',
  'wd.reject': 'Baztertu',
  'wd.mark_paid': 'Markatu ordainduta',
  'wd.empty': 'Eskaerarik ez',
  'cfg.title': 'Ordainketa ezarpenak',
  'cfg.rate_label': 'Ordainketa ikustaldiko ({cur})',
  'cfg.min_label': 'Gutxienekoa erretiratzeko ({cur})',
  'cfg.currency': 'Moneta',
  'cfg.save': 'Gorde',
  'cfg.saved': 'Ezarpenak gordeta',
  'trans.title': 'Hizkuntzak eta itzulpenak',
  'trans.intro': 'Igo JSON fitxategi bat edozein hizkuntza-kodetarako itzulpenekin (adib. ja, pt, zh). Fitxategiak gako → testu mapa laua eduki behar du.',
  'trans.code_label': 'Hizkuntza-kodea (adib. ja, pt-BR, zh)',
  'trans.name_label': 'Izena (hizkuntza horretan)',
  'trans.file_label': 'Itzulpenen JSON fitxategia',
  'trans.upload': 'Igo',
  'trans.uploaded': 'Itzulpenak gordeta',
  'trans.delete': 'Ezabatu',
  'trans.delete_confirm': 'Hizkuntza hau ezabatu?',
  'trans.builtin': 'Integratua',
  'trans.custom': 'Pertsonalizatua',
  'trans.empty_custom': 'Oraindik ez dago hizkuntza pertsonalizaturik.',
  'common.cancel': 'Utzi',
  'common.loading': 'Kargatzen...',
  'common.too_fast': 'Azkarregi, itxaron pixka bat',
  'time.few_seconds': 'duela segundo batzuk',
  'time.min': 'duela {n} min',
  'time.h': 'duela {n} h',
  'time.d': 'duela {n} e',
  'time.w': 'duela {n} ast',
  'time.mo': 'duela {n} hil',
  'time.y': 'duela {n} urt',
  'brand.tagline': 'Bideo laburrak. Benetako sortzaileak.',
  'live.section': 'Zuzenean',
  'live.start': 'Hasi zuzenekoa',
  'live.end': 'Amaitu zuzenekoa',
  'live.join': 'Sartu zuzenean',
  'live.chat_placeholder': 'Idatzi mezu bat...',
  'live.diamond': 'Diamantea',
  'live.buy_access': 'Erosi sarbidea',
  'live.save_recording': 'Gorde grabazioa',
};
